type Text3Prop = {
  text : string
}

const Text3 = ({text} : Text3Prop) => {
    return (
      <span className="text-text3">{text}</span>
    )
  }
  
  export default Text3